
export type GetTweetFeed200TweetsItemMediaItemType = typeof GetTweetFeed200TweetsItemMediaItemType[keyof typeof GetTweetFeed200TweetsItemMediaItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetFeed200TweetsItemMediaItemType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
} as const;
